import React from 'react';
import PropTypes from 'prop-types';
import CheckIcon from '@tradera/blueprint/theme/icons2/check.svg?jsx';
import CloseIcon from '@tradera/blueprint/theme/icons2/close.svg?jsx';
import { useTranslator } from 'tradera-lang/translate';

const FilterModalFooter = ({ handleModalClick }) => {
    const { t } = useTranslator();
    return (
        <div className="search-modal__footer p-2 bg-white d-flex" role="group">
            <button
                className="btn btn-fluid btn-outline-dark mr-2 text-nowrap"
                onClick={() => {
                    handleModalClick('');
                }}>
                <CloseIcon className="icon icon-sm mr-2 align-middle" />
                {t('searchFilterModal_close')}
            </button>
            <button
                className="btn btn-fluid btn-primary text-nowrap"
                onClick={() => {
                    handleModalClick('');
                }}>
                <CheckIcon className="icon icon-sm mr-2 align-middle" />
                {t('searchFilterModal_showItems')}
            </button>
        </div>
    );
};

FilterModalFooter.propTypes = {
    handleModalClick: PropTypes.func.isRequired
};

export default FilterModalFooter;
